import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "event" }
const _hoisted_2 = { class: "event__head" }
const _hoisted_3 = { class: "event__metadata" }
const _hoisted_4 = { class: "event__metadata-top" }
const _hoisted_5 = { class: "event__details" }
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_translated_text_component = _resolveComponent("translated-text-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.iconCode)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "event__icon",
            style: _normalizeStyle(`
        mask: url(data:image/svg+xml;base64,${_ctx.iconCode})
        no-repeat center; mask-size: contain;`)
          }, null, 4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.formattedDateTime) + " - " + _toDisplayString(_ctx.data.properties.name), 1),
        (_ctx.data.geometry)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "event__link",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.panAndShowModalForEvent(_ctx.data.geometry)), ["prevent"])),
              title: ""
            }, [
              _createVNode(_component_translated_text_component, { translation: "modal_show_on_map" })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "event__content",
        innerHTML: _ctx.data.properties.description
      }, null, 8, _hoisted_6)
    ])
  ]))
}